import { useStore } from '@stores';
import { InvoicePayment, TerminalMode } from '@services';
import { useCallback, useEffect } from 'react';
import { UseCardPaymentReturn } from '@models';


export const useCardPayment = (): UseCardPaymentReturn => {
  const { paymentStore } = useStore();

  useEffect(() => {
    return () => {
      paymentStore.cleanup();
    };
  }, [paymentStore]);

  const processCardPayment = useCallback(async (
    invoiceId: string, 
    amount: number, 
    terminalMode: TerminalMode,
    onSuccess: (paymentData: InvoicePayment) => Promise<void>
  ) => {
    return await paymentStore.processCardPayment(invoiceId, amount, terminalMode, onSuccess);
  }, [paymentStore]);

  const setCashPaymentLoading = useCallback((loading: boolean) => {
    paymentStore.setCashPaymentLoading(loading);
  }, [paymentStore]);

  const resetPaymentState = useCallback(() => {
    paymentStore.resetPaymentState();
  }, [paymentStore]);

  return {
    processingPayment: paymentStore.processingPayment,
    processingStatus: paymentStore.processingStatus,
    paymentFinished: paymentStore.paymentFinished,
    cardPaymentLoading: paymentStore.cardPaymentLoading,
    cashPaymentLoading: paymentStore.cashPaymentLoading,
    hasPaymentError: paymentStore.hasPaymentError,
    signatureRequired: paymentStore.signatureRequired,
    processCardPayment,
    setCashPaymentLoading,
    resetPaymentState,
    trackingId: paymentStore.trackingId,
    verifySignature: paymentStore.verifySignature,
  };
};